import { ContactRequestCard } from 'components/ContactRequestCard'
import { MobileInfiniteScrollView } from 'components/MobileInfiniteScrollView'
import { ContactRequestJobResponse } from 'models/contact_request'
import apiService from 'services/api'
import { ContactRequestJobPaginatedResponse } from 'services/contactRequestApi'

export function MobileContactRequestList({ page, filterAndSortParams }: any) {
  const api = apiService()

  const query = api.useGetContactRequestsInfinite({
    page,
    limit: 10,
    ...filterAndSortParams,
  })

  return (
    <MobileInfiniteScrollView<
      ContactRequestJobPaginatedResponse,
      ContactRequestJobResponse
    >
      infiniteQuery={query}
      extractItems={(page) => page.results}
    >
      {(requests) =>
        requests?.map((request: ContactRequestJobResponse) => (
          <ContactRequestCard key={request.id} contactRequest={request} />
        ))
      }
    </MobileInfiniteScrollView>
  )
}
